/**
 * Name component used to get the user's full name
 * - used with account creation
 * - depends on VX and the grid
 */

import PropTypes from 'prop-types';
import React from 'react';
import { TextInput } from '@paypalcorp/pp-react';

class Name extends React.Component {
    static propTypes = {
		firstNameLabel: PropTypes.string.isRequired,
		lastNameLabel: PropTypes.string.isRequired,
		required: PropTypes.bool,
		firstNameDefaultValue: PropTypes.string,
		lastNameDefaultValue: PropTypes.string,
		firstNameErrorMessage: PropTypes.string,
		lastNameErrorMessage: PropTypes.string,
		handleChangeFirstName: PropTypes.func.isRequired,
		handleChangeLastName: PropTypes.func.isRequired,
		handleBlurFirstName: PropTypes.func,
		handleBlurLastName: PropTypes.func,
	};

    static defaultProps = {
        handleBlurFirstName: () => {},
        handleBlurLastName: () => {},
    };

    state = {
        showFirstNameIsRequiredError: false,
        showLastNameIsRequiredError: false,
    };

    /**
	 * Check for a first name value if it's required
	 * @param {String} name - first name
	 */
    handleCheckFirstNameValue = (name) => {
		this.setState({ showFirstNameIsRequiredError: this.props.required && !name });
	};

    /**
	 * Check for a last name value if it's required
	 * @param {String} name - last name
	 */
    handleCheckLastNameValue = (name) => {
		this.setState({ showLastNameIsRequiredError: this.props.required && !name });
	};

	handleChangeFirstName = (firstName, mssg_error) => {
		this.handleCheckFirstNameValue(firstName);
		this.props.handleChangeFirstName(firstName, mssg_error);
		return firstName;
	};

    handleChangeLastName = (lastName, mssg_error) => {
		this.handleCheckLastNameValue(lastName);
		this.props.handleChangeLastName(lastName, mssg_error);
		return lastName;
	};

    handleBlurFirstName = (firstName) => {
		this.handleCheckFirstNameValue(firstName);
		this.props.handleBlurFirstName(firstName);
	};

    handleBlurLastName = (lastName) => {
		this.handleCheckLastNameValue(lastName);
		this.props.handleBlurLastName(lastName);
	};

    render() {
		let { firstNameErrorMessage, lastNameErrorMessage } = this.props;

		return (
            <div className="ppvx_row">
				<div className="ppvx_col-md-6" style={{ margin: '10px 0' }}>
					<TextInput
						name="firstName"
						id="firstName"
						label={this.props.firstNameLabel}
						required={this.props.required}
						value={this.props.firstNameDefaultValue}
						onChange={(event) => this.handleChangeFirstName(event.target.value, 'firstNameErrorMessage')}
						onBlur={(event) => this.handleBlurFirstName(event.target.value)}
						errorText={firstNameErrorMessage}
					/>
				</div>
				<div className="ppvx_col-md-6" style={{ margin: '10px 0' }}>
					<TextInput
						name="lastName"
						id="lastName"
						label={this.props.lastNameLabel}
						required={this.props.required}
						value={this.props.lastNameDefaultValue}
						onChange={(event) => this.handleChangeLastName(event.target.value, ('lastNameErrorMessage'))}
						onBlur={(event) => this.handleBlurLastName(event.target.value)}
						errorText={lastNameErrorMessage}
					/>
				</div>
			</div>
        );
	}
}

export default Name;
